import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../../Component/Model/helpers';

export const demographicDeviationSchema = yup.object({
    demographicGroup: yup
        .string()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .required('Demographic Group is required'),
    reasonId: yup
        .number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .required('Justification Reason is required')
        .typeError('Justification Reason is required'),
    comment: yup
        .string()
        .nullable()
        .required('Comment is required')
        .test('commentLengthTest', 'Comment is too long (Max length is 6000 characters)', (value) => {
            if (!value) {
                return true;
            }
            return DataTableHtmlFormatter(value, '').length <= 6000;
        }),
    plannedDemographicGroups: yup.array().of(yup.string()),
    actualDemographicGroups: yup.array().of(yup.string()),
    remedialPlan: yup
        .string()
        .nullable()
        .test('remedialPlanLengthTest', 'Remedial Plan is too long (Max length is 1000 characters)', (value) => {
            if (!value) {
                return true;
            }
            return DataTableHtmlFormatter(value, '').length <= 1000;
        }),
});
